import {
  FulfillmentType,
  IMealCreditFormFields,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';

export const getFulfillmentTypes = (
  fulfillmentTypes: IMealCredit['fulfillment_types']
): IMealCreditFormFields['fulfillmentType'] =>
  fulfillmentTypes.map((type) => FulfillmentType[type]);
